import ActiveBookings from '@commons/bookings/active'
import React from 'react'

const ProviderActiveBookings = ({ user }) => {
  return <ActiveBookings user={user} />
}

export default ProviderActiveBookings
